export const practiceType = (data) => {
  if (data.likertYN === "Y" && data.ipsativeYN === "Y") return "TYPE1";
  // 척도 O
  else if (data.likertYN === "Y" && data.ipsativeYN === "N") return "TYPE2";
  // 척도 O
  else if (data.likertYN === "N" && data.ipsativeYN === "Y") return "TYPE3";
  // 척도 X
  else if (data.likertYN === "N" && data.ipsativeYN === "N") return "APTITUDE";
};
